module.exports = "https://bin.bnbstatic.com/_next/static/images/Alessandro Preti-07f7e6685651026b84b3bc97a2ed0874.jpg";